// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "", "",{"version":3,"sources":[],"names":[],"mappings":"","file":"themes.module.scss"}]);
// Exports
exports.locals = {
	"var-palette-default-background": "#fff",
	"var-palette-default-text": "#000",
	"var-palette-default-headline": "#000",
	"var-palette-default-logo": "#000",
	"var-palette-default-interactive": "#ccc",
	"var-palette-default-interactive-hover": "#000",
	"var-palette-default-interactive-active": "#333",
	"var-palette-default-interactive-reverse": "#5d5d5d",
	"var-storybook-font-collection-object-default-size": "default-size",
	"var-storybook-font-collection-object-breakpoint-xsmall": "breakpoint-xsmall",
	"var-storybook-font-collection-object-breakpoint-small": "breakpoint-small",
	"var-storybook-font-collection-object-breakpoint-medium": "breakpoint-medium",
	"var-storybook-font-collection-object-breakpoint-large": "breakpoint-large",
	"var-storybook-font-collection-object-breakpoint-xlarge": "breakpoint-xlarge",
	"var-storybook-font-collection-name-body-text": "body-text",
	"var-storybook-font-set-body-text-default": "default",
	"var-storybook-font-body-text-default-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-body-text-default-font-weight": "400",
	"var-storybook-font-body-text-default-text-transform": "none",
	"var-storybook-font-body-text-default-letter-spacing": ".56px",
	"var-storybook-font-body-text-default-default-size-line-height": "1.2307692308",
	"var-storybook-font-body-text-default-default-size-font-size": ".875rem",
	"var-storybook-font-set-body-text-meta": "meta",
	"var-storybook-font-body-text-meta-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-body-text-meta-font-weight": "400",
	"var-storybook-font-body-text-meta-text-transform": "none",
	"var-storybook-font-body-text-meta-letter-spacing": ".56px",
	"var-storybook-font-body-text-meta-default-size-line-height": "1.3333",
	"var-storybook-font-body-text-meta-default-size-font-size": ".75rem",
	"var-storybook-font-set-body-text-paragraph": "paragraph",
	"var-storybook-font-body-text-paragraph-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-body-text-paragraph-font-weight": "400",
	"var-storybook-font-body-text-paragraph-text-transform": "none",
	"var-storybook-font-body-text-paragraph-letter-spacing": ".56px",
	"var-storybook-font-body-text-paragraph-default-size-line-height": "1.2307692308",
	"var-storybook-font-body-text-paragraph-default-size-font-size": ".875rem",
	"var-storybook-font-set-body-text-preamble": "preamble",
	"var-storybook-font-body-text-preamble-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-body-text-preamble-font-weight": "700",
	"var-storybook-font-body-text-preamble-text-transform": "none",
	"var-storybook-font-body-text-preamble-letter-spacing": ".56px",
	"var-storybook-font-body-text-preamble-default-size-line-height": "1.1666",
	"var-storybook-font-body-text-preamble-default-size-font-size": "1.5rem",
	"var-storybook-font-collection-name-button": "button",
	"var-storybook-font-set-button-s": "s",
	"var-storybook-font-button-s-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-button-s-font-weight": "700",
	"var-storybook-font-button-s-text-transform": "none",
	"var-storybook-font-button-s-letter-spacing": ".56px",
	"var-storybook-font-button-s-default-size-line-height": "1.285714286",
	"var-storybook-font-button-s-default-size-font-size": ".875rem",
	"var-storybook-font-collection-name-heading": "heading",
	"var-storybook-font-set-heading-xs": "xs",
	"var-storybook-font-heading-xs-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-heading-xs-font-weight": "700",
	"var-storybook-font-heading-xs-text-transform": "none",
	"var-storybook-font-heading-xs-letter-spacing": ".56px",
	"var-storybook-font-heading-xs-default-size-line-height": "1.2",
	"var-storybook-font-heading-xs-default-size-font-size": ".875rem",
	"var-storybook-font-set-heading-s": "s",
	"var-storybook-font-heading-s-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-heading-s-font-weight": "700",
	"var-storybook-font-heading-s-text-transform": "none",
	"var-storybook-font-heading-s-letter-spacing": ".56px",
	"var-storybook-font-heading-s-default-size-line-height": "1.2",
	"var-storybook-font-heading-s-default-size-font-size": ".875rem",
	"var-storybook-font-set-heading-m": "m",
	"var-storybook-font-heading-m-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-heading-m-font-weight": "700",
	"var-storybook-font-heading-m-text-transform": "none",
	"var-storybook-font-heading-m-letter-spacing": ".56px",
	"var-storybook-font-heading-m-default-size-line-height": "1.2",
	"var-storybook-font-heading-m-default-size-font-size": "1.25rem",
	"var-storybook-font-set-heading-l": "l",
	"var-storybook-font-heading-l-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-heading-l-font-weight": "700",
	"var-storybook-font-heading-l-text-transform": "none",
	"var-storybook-font-heading-l-letter-spacing": ".56px",
	"var-storybook-font-heading-l-default-size-line-height": "1.1666",
	"var-storybook-font-heading-l-default-size-font-size": "1.5rem",
	"var-storybook-font-heading-l-breakpoint-medium-line-height": "1.125",
	"var-storybook-font-heading-l-breakpoint-medium-font-size": "2rem",
	"var-storybook-font-set-heading-xl": "xl",
	"var-storybook-font-heading-xl-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-heading-xl-font-weight": "700",
	"var-storybook-font-heading-xl-text-transform": "none",
	"var-storybook-font-heading-xl-letter-spacing": ".56px",
	"var-storybook-font-heading-xl-default-size-line-height": "1.1428",
	"var-storybook-font-heading-xl-default-size-font-size": "1.75rem",
	"var-storybook-font-heading-xl-breakpoint-medium-line-height": "1.1111",
	"var-storybook-font-heading-xl-breakpoint-medium-font-size": "2.25rem",
	"var-storybook-font-set-heading-pre-heading": "pre-heading",
	"var-storybook-font-heading-pre-heading-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-heading-pre-heading-font-weight": "400",
	"var-storybook-font-heading-pre-heading-text-transform": "uppercase",
	"var-storybook-font-heading-pre-heading-default-size-line-height": "1.25",
	"var-storybook-font-heading-pre-heading-default-size-font-size": "1rem",
	"var-storybook-font-collection-name-display": "display",
	"var-storybook-font-set-display-default": "default",
	"var-storybook-font-display-default-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-display-default-font-weight": "700",
	"var-storybook-font-display-default-text-transform": "none",
	"var-storybook-font-display-default-letter-spacing": ".56px",
	"var-storybook-font-display-default-default-size-line-height": "1.1111",
	"var-storybook-font-display-default-default-size-font-size": "1.75rem",
	"var-storybook-font-display-default-breakpoint-medium-line-height": "1.083333333",
	"var-storybook-font-display-default-breakpoint-medium-font-size": "3rem",
	"var-storybook-font-set-display-quote": "quote",
	"var-storybook-font-display-quote-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-display-quote-font-weight": "700",
	"var-storybook-font-display-quote-text-transform": "none",
	"var-storybook-font-display-quote-default-size-line-height": "1.1111",
	"var-storybook-font-display-quote-default-size-font-size": "2rem",
	"var-storybook-font-display-quote-breakpoint-medium-line-height": "1.083333333",
	"var-storybook-font-display-quote-breakpoint-medium-font-size": "3.75rem",
	"var-storybook-font-collection-name-price": "price",
	"var-storybook-font-set-price-original-default": "original-default",
	"var-storybook-font-price-original-default-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-price-original-default-font-weight": "400",
	"var-storybook-font-price-original-default-text-transform": "none",
	"var-storybook-font-price-original-default-text-decoration": "line-through",
	"var-storybook-font-price-original-default-letter-spacing": ".56px",
	"var-storybook-font-price-original-default-default-size-line-height": "1.1428",
	"var-storybook-font-price-original-default-default-size-font-size": ".875rem",
	"var-storybook-font-set-price-original-large": "original-large",
	"var-storybook-font-price-original-large-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-price-original-large-font-weight": "400",
	"var-storybook-font-price-original-large-text-transform": "none",
	"var-storybook-font-price-original-large-text-decoration": "line-through",
	"var-storybook-font-price-original-large-letter-spacing": ".56px",
	"var-storybook-font-price-original-large-default-size-line-height": "1.1428",
	"var-storybook-font-price-original-large-default-size-font-size": ".875rem",
	"var-storybook-font-set-price-black-default": "black-default",
	"var-storybook-font-price-black-default-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-price-black-default-font-weight": "400",
	"var-storybook-font-price-black-default-text-transform": "none",
	"var-storybook-font-price-black-default-letter-spacing": ".56px",
	"var-storybook-font-price-black-default-default-size-line-height": "1.1428",
	"var-storybook-font-price-black-default-default-size-font-size": ".875rem",
	"var-storybook-font-set-price-black-large": "black-large",
	"var-storybook-font-price-black-large-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-price-black-large-font-weight": "400",
	"var-storybook-font-price-black-large-text-transform": "none",
	"var-storybook-font-price-black-large-letter-spacing": ".56px",
	"var-storybook-font-price-black-large-default-size-line-height": "1.1428",
	"var-storybook-font-price-black-large-default-size-font-size": ".875rem",
	"var-storybook-font-set-price-previous-meta": "previous-meta",
	"var-storybook-font-price-previous-meta-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-price-previous-meta-font-weight": "400",
	"var-storybook-font-price-previous-meta-text-transform": "none",
	"var-storybook-font-price-previous-meta-text-decoration": "line-through",
	"var-storybook-font-price-previous-meta-letter-spacing": ".56px",
	"var-storybook-font-price-previous-meta-default-size-line-height": "1.3333",
	"var-storybook-font-price-previous-meta-default-size-font-size": ".75rem",
	"var-storybook-font-collection-name-label": "label",
	"var-storybook-font-set-label-form-label": "form-label",
	"var-storybook-font-label-form-label-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-label-form-label-font-weight": "400",
	"var-storybook-font-label-form-label-text-transform": "none",
	"var-storybook-font-label-form-label-letter-spacing": ".56px",
	"var-storybook-font-label-form-label-default-size-line-height": "1.1428",
	"var-storybook-font-label-form-label-default-size-font-size": ".875rem",
	"var-storybook-font-collection-name-interactive": "interactive",
	"var-storybook-font-set-interactive-navigation-parent": "navigation-parent",
	"var-storybook-font-interactive-navigation-parent-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-interactive-navigation-parent-font-weight": "700",
	"var-storybook-font-interactive-navigation-parent-text-transform": "none",
	"var-storybook-font-interactive-navigation-parent-text-decoration": "none",
	"var-storybook-font-interactive-navigation-parent-default-size-line-height": "1.1111",
	"var-storybook-font-interactive-navigation-parent-default-size-font-size": "1.125rem",
	"var-storybook-font-set-interactive-navigation-child": "navigation-child",
	"var-storybook-font-interactive-navigation-child-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-interactive-navigation-child-font-weight": "700",
	"var-storybook-font-interactive-navigation-child-text-transform": "none",
	"var-storybook-font-interactive-navigation-child-text-decoration": "none",
	"var-storybook-font-interactive-navigation-child-letter-spacing": ".56",
	"var-storybook-font-interactive-navigation-child-default-size-line-height": "1.166",
	"var-storybook-font-interactive-navigation-child-default-size-font-size": "1.5rem",
	"var-storybook-font-set-interactive-navigation-large": "navigation-large",
	"var-storybook-font-interactive-navigation-large-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-interactive-navigation-large-font-weight": "700",
	"var-storybook-font-interactive-navigation-large-text-transform": "none",
	"var-storybook-font-interactive-navigation-large-text-decoration": "none",
	"var-storybook-font-interactive-navigation-large-default-size-line-height": "1.1111",
	"var-storybook-font-interactive-navigation-large-default-size-font-size": "1.125rem",
	"var-storybook-font-set-interactive-navigation-medium": "navigation-medium",
	"var-storybook-font-interactive-navigation-medium-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-interactive-navigation-medium-font-weight": "700",
	"var-storybook-font-interactive-navigation-medium-text-transform": "none",
	"var-storybook-font-interactive-navigation-medium-text-decoration": "none",
	"var-storybook-font-interactive-navigation-medium-letter-spacing": ".56",
	"var-storybook-font-interactive-navigation-medium-default-size-line-height": "1.166",
	"var-storybook-font-interactive-navigation-medium-default-size-font-size": "1.5rem",
	"var-storybook-font-set-interactive-navigation-small": "navigation-small",
	"var-storybook-font-interactive-navigation-small-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-navigation-small-font-weight": "400",
	"var-storybook-font-interactive-navigation-small-text-transform": "none",
	"var-storybook-font-interactive-navigation-small-text-decoration": "none",
	"var-storybook-font-interactive-navigation-small-default-size-line-height": "1.2",
	"var-storybook-font-interactive-navigation-small-default-size-font-size": ".625rem",
	"var-storybook-font-set-interactive-inline-link-default": "inline-link-default",
	"var-storybook-font-interactive-inline-link-default-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-inline-link-default-font-weight": "400",
	"var-storybook-font-interactive-inline-link-default-text-transform": "none",
	"var-storybook-font-interactive-inline-link-default-text-decoration": "underline",
	"var-storybook-font-interactive-inline-link-default-letter-spacing": ".56px",
	"var-storybook-font-interactive-inline-link-default-default-size-line-height": "1.2307692308",
	"var-storybook-font-interactive-inline-link-default-default-size-font-size": ".875rem",
	"var-storybook-font-set-interactive-inline-link-meta": "inline-link-meta",
	"var-storybook-font-interactive-inline-link-meta-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-inline-link-meta-font-weight": "400",
	"var-storybook-font-interactive-inline-link-meta-text-transform": "none",
	"var-storybook-font-interactive-inline-link-meta-text-decoration": "underline",
	"var-storybook-font-interactive-inline-link-meta-letter-spacing": ".56px",
	"var-storybook-font-interactive-inline-link-meta-default-size-line-height": "1.3333",
	"var-storybook-font-interactive-inline-link-meta-default-size-font-size": ".75rem",
	"var-storybook-font-set-interactive-inline-link-paragraph": "inline-link-paragraph",
	"var-storybook-font-interactive-inline-link-paragraph-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-inline-link-paragraph-font-weight": "400",
	"var-storybook-font-interactive-inline-link-paragraph-text-transform": "none",
	"var-storybook-font-interactive-inline-link-paragraph-text-decoration": "underline",
	"var-storybook-font-interactive-inline-link-paragraph-letter-spacing": ".56px",
	"var-storybook-font-interactive-inline-link-paragraph-default-size-line-height": "1.2307692308",
	"var-storybook-font-interactive-inline-link-paragraph-default-size-font-size": ".875rem",
	"var-storybook-font-set-interactive-inline-link-preamble": "inline-link-preamble",
	"var-storybook-font-interactive-inline-link-preamble-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-interactive-inline-link-preamble-font-weight": "700",
	"var-storybook-font-interactive-inline-link-preamble-text-transform": "none",
	"var-storybook-font-interactive-inline-link-preamble-letter-spacing": ".56px",
	"var-storybook-font-interactive-inline-link-preamble-default-size-line-height": "1.1666",
	"var-storybook-font-interactive-inline-link-preamble-default-size-font-size": "1.5rem",
	"var-storybook-font-set-interactive-standalone-link": "standalone-link",
	"var-storybook-font-interactive-standalone-link-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-standalone-link-font-weight": "700",
	"var-storybook-font-interactive-standalone-link-text-transform": "none",
	"var-storybook-font-interactive-standalone-link-text-decoration": "underline",
	"var-storybook-font-interactive-standalone-link-letter-spacing": ".56px",
	"var-storybook-font-interactive-standalone-link-default-size-line-height": "1.285714286",
	"var-storybook-font-interactive-standalone-link-default-size-font-size": ".875rem",
	"var-storybook-font-set-interactive-standalone-link-default": "standalone-link-default",
	"var-storybook-font-interactive-standalone-link-default-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-standalone-link-default-font-weight": "400",
	"var-storybook-font-interactive-standalone-link-default-text-transform": "none",
	"var-storybook-font-interactive-standalone-link-default-text-decoration": "none",
	"var-storybook-font-interactive-standalone-link-default-default-size-line-height": "1.52",
	"var-storybook-font-interactive-standalone-link-default-default-size-font-size": "1rem",
	"var-storybook-font-set-interactive-standalone-link-underline": "standalone-link-underline",
	"var-storybook-font-interactive-standalone-link-underline-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-standalone-link-underline-font-weight": "400",
	"var-storybook-font-interactive-standalone-link-underline-text-decoration": "underline",
	"var-storybook-font-interactive-standalone-link-underline-text-transform": "none",
	"var-storybook-font-interactive-standalone-link-underline-default-size-line-height": "1.52",
	"var-storybook-font-interactive-standalone-link-underline-default-size-font-size": "1rem",
	"var-storybook-font-set-interactive-input-text": "input-text",
	"var-storybook-font-interactive-input-text-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-input-text-font-weight": "400",
	"var-storybook-font-interactive-input-text-text-transform": "none",
	"var-storybook-font-interactive-input-text-letter-spacing": ".56px",
	"var-storybook-font-interactive-input-text-default-size-line-height": "1.25",
	"var-storybook-font-interactive-input-text-default-size-font-size": "1rem",
	"var-storybook-font-set-interactive-element": "element",
	"var-storybook-font-interactive-element-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-interactive-element-font-weight": "700",
	"var-storybook-font-interactive-element-text-transform": "none",
	"var-storybook-font-interactive-element-letter-spacing": ".56px",
	"var-storybook-font-interactive-element-default-size-line-height": "1.285714286",
	"var-storybook-font-interactive-element-default-size-font-size": ".875rem",
	"var-storybook-font-collection-name-editorial": "editorial",
	"var-storybook-font-set-editorial-display-quote": "display-quote",
	"var-storybook-font-editorial-display-quote-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-editorial-display-quote-font-weight": "700",
	"var-storybook-font-editorial-display-quote-font-style": "italic",
	"var-storybook-font-editorial-display-quote-text-transform": "none",
	"var-storybook-font-editorial-display-quote-letter-spacing": ".56px",
	"var-storybook-font-editorial-display-quote-default-size-line-height": "1.1111111111",
	"var-storybook-font-editorial-display-quote-default-size-font-size": "2.25rem",
	"var-storybook-font-editorial-display-quote-breakpoint-medium-line-height": "1.0833333333",
	"var-storybook-font-editorial-display-quote-breakpoint-medium-font-size": "3rem",
	"var-storybook-font-set-editorial-preamble": "preamble",
	"var-storybook-font-editorial-preamble-font-family": "\"Stories Serif\",\"Times New Roman\",Times",
	"var-storybook-font-editorial-preamble-font-weight": "700",
	"var-storybook-font-editorial-preamble-text-transform": "none",
	"var-storybook-font-editorial-preamble-letter-spacing": ".56px",
	"var-storybook-font-editorial-preamble-default-size-line-height": "1.1666666667",
	"var-storybook-font-editorial-preamble-default-size-font-size": "1.5rem",
	"var-storybook-font-set-editorial-body-text": "body-text",
	"var-storybook-font-editorial-body-text-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-editorial-body-text-font-weight": "400",
	"var-storybook-font-editorial-body-text-text-transform": "none",
	"var-storybook-font-editorial-body-text-letter-spacing": ".56px",
	"var-storybook-font-editorial-body-text-default-size-line-height": "1.5",
	"var-storybook-font-editorial-body-text-default-size-font-size": ".875rem",
	"var-storybook-font-set-editorial-text-link": "text-link",
	"var-storybook-font-editorial-text-link-font-family": "\"Monument Grotesk Semi Mono\",\"Courier New\",Courier",
	"var-storybook-font-editorial-text-link-font-weight": "700",
	"var-storybook-font-editorial-text-link-text-transform": "none",
	"var-storybook-font-editorial-text-link-text-decoration": "underline",
	"var-storybook-font-editorial-text-link-letter-spacing": ".56px",
	"var-storybook-font-editorial-text-link-default-size-line-height": "1.5",
	"var-storybook-font-editorial-text-link-default-size-font-size": ".875rem",
	"var-other-spacings-$field-height": "48px",
	"var-other-spacings-$button-standard-height": "48px",
	"var-other-spacings-$mobile-header-height": "72px",
	"var-other-spacings-$vertical-scroll-breakpoint-desktop": "1001px",
	"var-other-spacings-$swipe-in-sidebarpluscontent": "1062px",
	"var-other-spacings-$grid-column-width": "58px",
	"var-other-spacings-$grid-column-gutter": "24px",
	"var-other-spacings-$grid-gutter": "24px",
	"var-other-spacings-$grid-gutter-pixels": "24px",
	"var-other-spacings-$grid-side-gutter": "24px",
	"var-other-spacings-$grid-gutter-level-one-percent": "2.5%",
	"var-other-spacings-$grid-gutter-level-two-percent": "3.35%",
	"var-other-spacings-$teaser-gutter": "15px",
	"var-other-spacings-$teaser-s-gutter": "20px",
	"var-other-spacings-$teaser-m-gutter": "30px",
	"var-other-spacings-$teaser-l-gutter": "40px",
	"var-other-spacings-$teaser-gutter-3x2": "12.5%",
	"var-other-spacings-$side-margins-xs": "15px",
	"var-other-spacings-$background-plate-gutter": "20px",
	"var-other-spacings-$modal-padding": "64px",
	"var-other-spacings-$modal-mobile-padding": "24px",
	"var-other-spacings-$mobile-height": "72px",
	"var-other-spacings-$desktop-height": "72px",
	"var-other-spacings-$hamburger-menu-height": "30px",
	"var-other-spacings-$megamenu-height": "72px",
	"var-other-spacings-$option-max-height": "103px",
	"var-other-spacings-$side-margins": "60px",
	"var-other-spacings-$side-margins-large": "80px",
	"var-other-spacings-$meta-min-width": "85px",
	"var-other-spacings-$form-input-height": "52px",
	"var-other-spacings-$sidebar-width": "224px",
	"var-other-spacings-$centerd-block-width": "714px",
	"var-other-spacings-$sidebar-width-pixels": "224px",
	"var-other-spacings-$spinner-small": "16px",
	"var-other-spacings-$spinner-medium": "24px",
	"var-other-spacings-$spinner-large": "32px",
	"var-breakpoint-xsmall_breakpoint": "320px",
	"var-breakpoint-small_breakpoint": "420px",
	"var-breakpoint-medium_breakpoint": "768px",
	"var-breakpoint-large_breakpoint": "1024px",
	"var-breakpoint-xlarge_breakpoint": "1280px",
	"var-transitions-$ui-animation-speed": ".2s",
	"var-transitions-$multiple-cta-animation-speed": ".2s",
	"var-transitions-$transition-duration": "300ms",
	"var-z-index-$header-z-index": "1003",
	"var-z-index-$overlay-z-index": "1010",
	"var-z-index-$focus-trap-overlay-z-index": "1008",
	"var-z-index-$sizepicker-z-index": "1009",
	"var-z-index-$sidebar-z-index": "1020",
	"var-z-index-$notification-z-index": "1030",
	"var-z-index-$component-base-z-index": "1",
	"var-z-index-$component-text-z-index": "2",
	"var-z-index-$component-overlay-z-index": "3",
	"var-responsive-width-$responsive-width-xsmall": "320px",
	"var-responsive-width-$responsive-width-small": "420px",
	"var-responsive-width-$responsive-width-medium": "768px",
	"var-responsive-width-$responsive-width-large": "1024px",
	"var-responsive-width-$responsive-width-xlarge": "1280px",
	"var-responsive-width-$responsive-width-xxl": "2560px",
	"var-container-width-$container-width-medium": "584px",
	"var-container-width-$container-width-large": "676px",
	"var-container-width-$container-width-xlarge": "1140px",
	"var-container-width-$container-width-xxlarge": "1552px",
	"var-container-width-$wrapper-width-desktop": "960px",
	"var-container-width-$inner-content-width": "329px",
	"var-container-width-$editorial-content-max-width": "1030px",
	"var-container-width-$editorial-media-max-width": "910px",
	"var-theme-name": "OtherStories",
	"var-palette-name-default": "\"default\""
};
module.exports = exports;
